import { Stack } from "@mui/material";

export const DoitLoading = () => (
  <Stack sx={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
    <img src="/doit-loading.gif" alt="Loading" style={{ height: 170 }} />
  </Stack>
);
